import React from 'react'
import PropTypes from 'prop-types'
import { Button, Popconfirm, Table } from 'antd'
import { DeleteOutlined } from '@ant-design/icons'
import './styles.css'

const { Column } = Table

const ReportsWorkOrderTable = ({ data, onRemoveReportWorkOrder, loading, items = [] }) => {
    const getItemName = (itemId) => {
        const item = items.find(item => item.id === itemId)
        return item ? `${item.name}` : `Item ${itemId}`
    }
    
    return (
        <Table className="reportWorkOrderTableCont" dataSource={data} rowKey="position" size="small" pagination={false}
               scroll={{ x: 1000 }}>
            <Column title="Fecha informe" dataIndex="reportDate" key="reportDate" align="center" width="15%"/>
            <Column title="Tarea realizada" dataIndex="taskDone" key="taskDone" align="center" width="25%"/>
            <Column title="Item" dataIndex="itemId" key="itemId" align="center" width="15%"
                    render={(text, record) => {
                        // Compatibilidad: si tiene area (reportes antiguos), mostrar área, sino mostrar item
                        if (record.area) {
                            return record.area
                        }
                        return record.itemId ? getItemName(record.itemId) : '-'
                    }}/>
            <Column title="% Estimado de avance" dataIndex="reportCompletionPercentage" key="reportCompletionPercentage"
                    align="center" width="10%"
                    render={(text, record) => `${record.reportCompletionPercentage}%`}/>
            <Column title="Mensaje" dataIndex="message" key="message" align="center" width="25%"/>
            <Column title="" dataIndex="actions" key="actions" align="center" width="10%" render={(text, record) =>
                <Popconfirm disabled={loading} title="Se borrará la tarea, ¿Continuar?"
                            onConfirm={() => onRemoveReportWorkOrder(record.position)}>
                    <Button loading={loading}>{!loading && <DeleteOutlined style={{ color: 'red' }}/>}</Button>
                </Popconfirm>
            }/>
        </Table>
    )
}

ReportsWorkOrderTable.propTypes = {
    data: PropTypes.array,
    loading: PropTypes.bool,
    items: PropTypes.array
}

export default ReportsWorkOrderTable
